<template>
  <div>
    <div class="padding10 border borderRadius10 marginBottom10" style="line-height: 30px; height: 150px;">
      <div class="fs13">
        {{ ccode + storeName }}
        <div style="float: right">
          <svg t="1730201393860" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="17082" width="16" height="16" @click="handleStoreImgUrlHref">
            <path
              d="M831.792397 82.404802 191.548594 82.404802c-60.676941 0-110.042255 49.364291-110.042255 110.042255l0 640.245849c0 60.677964 49.364291 110.042255 110.042255 110.042255l640.244826 0c60.677964 0 110.042255-49.364291 110.042255-110.042255L941.835675 192.447057C941.834652 131.769093 892.470361 82.404802 831.792397 82.404802zM191.548594 122.420167l640.244826 0c38.612413 0 70.02689 31.414477 70.02689 70.02689l0 134.349871c-144.759965 4.953825-280.06151 63.59234-382.864898 166.396751-48.28061 48.28061-86.814228 103.732549-114.628714 163.962306-80.588433-68.744687-197.638289-73.051783-282.803971-12.938684L121.522728 192.447057C121.521704 153.834644 152.935158 122.420167 191.548594 122.420167zM121.521704 832.691883l0-136.601144c74.040297-72.025407 192.529945-71.925123 266.451538 0.301875-23.496134 62.998823-35.762505 130.383536-35.762505 199.672622 0 2.336208 0.420579 4.569062 1.157359 6.652514L191.548594 902.717749C152.935158 902.718773 121.521704 871.304296 121.521704 832.691883zM831.792397 902.718773 391.068743 902.718773c0.735757-2.084475 1.157359-4.317329 1.157359-6.652514 0-141.581576 55.054897-274.608312 155.023726-374.578164 95.245248-95.245248 220.499973-149.720953 354.570481-154.655336l0 465.860147C901.819287 871.304296 870.40481 902.718773 831.792397 902.718773z"
              fill="#272636"
              p-id="17083"
            ></path>
            <path d="M349.471346 477.533001c75.04723 0 136.102794-61.054541 136.102794-136.101771s-61.055564-136.102794-136.102794-136.102794-136.102794 61.055564-136.102794 136.102794S274.424116 477.533001 349.471346 477.533001zM349.471346 245.343801c52.982702 0 96.087429 43.104727 96.087429 96.087429 0 52.982702-43.104727 96.087429-96.087429 96.087429-52.982702 0-96.087429-43.104727-96.087429-96.087429C253.383918 288.448528 296.488645 245.343801 349.471346 245.343801z" fill="#272636" p-id="17084"></path>
          </svg>
          &nbsp;
          <svg t="1730201560684" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="17319" width="16" height="16" @click="handleStoreVideoShow">
            <path d="M901.12 0H122.88C53.248 0 0 53.248 0 122.88v778.24c0 65.536 53.248 122.88 122.88 122.88h778.24c69.632 0 122.88-57.344 122.88-122.88V122.88c0-69.632-53.248-122.88-122.88-122.88z m81.92 901.12c0 45.056-36.864 81.92-81.92 81.92H122.88c-45.056 0-81.92-36.864-81.92-81.92V122.88c0-45.056 36.864-81.92 81.92-81.92h778.24c45.056 0 81.92 36.864 81.92 81.92v778.24z" fill="#666666" p-id="17320"></path>
            <path d="M741.376 471.04l-159.744-90.112-159.744-90.112c-4.096-4.096-8.192-8.192-16.384-8.192-20.48 0-36.864 16.384-36.864 40.96v368.64c0 20.48 16.384 36.864 36.864 36.864 8.192 0 12.288 0 20.48-4.096l159.744-90.112 159.744-90.112c20.48-20.48 20.48-57.344-4.096-73.728z m-180.224 122.88L409.6 684.032V327.68l151.552 90.112 151.552 90.112-151.552 86.016z" fill="#666666" p-id="17321"></path>
            <path d="M839.68 839.68m-61.44 0a61.44 61.44 0 1 0 122.88 0 61.44 61.44 0 1 0-122.88 0Z" fill="#9EB9FD" p-id="17322"></path>
          </svg>
          &nbsp;
          <svg t="1730201637494" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="17734" width="16" height="16" @click="handleStoreVideoUrlCopy"><path d="M746 161.6c0 14.8-9.9 24.7-24.7 24.7-14.8 0-24.7-9.9-24.7-24.7v-32.2c0-42-32.2-74.2-74.2-74.2H127.7c-42 0-74.2 32.2-74.2 74.2V624c0 42 32.2 74.2 74.2 74.2h39.6c14.8 0 24.7 9.9 24.7 24.7 0 14.8-9.9 24.7-24.7 24.7h-39.6C58.4 747.7 4 693.3 4 624V129.4C4 60.2 58.4 5.7 127.7 5.7h494.6C691.5 5.7 746 60.2 746 129.4v32.2z m272 549c0 14.8-9.9 24.7-24.7 24.7-14.8 0-24.7-9.9-24.7-24.7V401.5c0-42-32.2-74.2-74.2-74.2H399.7c-42 0-74.2 32.2-74.2 74.2v494.6c0 42 32.2 74.2 74.2 74.2h494.6c42 0 74.2-32.2 74.2-74.2v-54.4c0-14.8 9.9-24.7 24.7-24.7 14.8 0 24.7 9.9 24.7 24.7v54.4c0 69.2-54.4 123.7-123.7 123.7H399.7c-69.2 0-123.7-54.4-123.7-123.7V401.5c0-69.2 54.4-123.7 123.7-123.7h494.6c69.2 0 123.7 54.4 123.7 123.7v309.1z" fill="#333333" p-id="17735"></path></svg>
        </div>
      </div>
      <a class="purple fs13">{{ storeAddr }}</a>
    </div>
    <div class="padding10 border borderRadius10 marginBottom10" style="height: 300px;">
      <div class="borderBottom" style="padding-bottom: 5px; margin-bottom: 5px">
        <span class="fs20">门店监控</span>
        <el-switch v-model="isDialog" active-text="弹窗" inactive-text="标签" style="float: right;"></el-switch>
      </div>
      <div class="flex directionColumn">
        <br />
        <el-row>
          <el-col v-for="item in deviceList" :key="item.id" :span="6" style="text-align: center">
            <svg height="64" width="64" p-id="18274" xmlns="http://www.w3.org/2000/svg" style="cursor: pointer" t="1730201674113" class="icon" viewBox="0 0 1024 1024" version="1.1" @click="openVideo(item)">
              <path d="M512 618.3936a174.08 174.08 0 1 1 174.7968-174.08 174.08 174.08 0 0 1-174.7968 174.08z m-58.2656-174.08a57.9584 57.9584 0 1 0-58.2656-58.0608 58.2656 58.2656 0 0 0 58.2656 58.0608z m-19.456 309.4528h155.4432v116.0192H434.2784zM298.2912 869.7856h427.4176a38.7072 38.7072 0 1 1 0 77.4144H298.2912a38.7072 38.7072 0 1 1 0-77.4144z m0 0" p-id="18275"></path>
              <path d="M512 734.4128a290.9184 290.9184 0 1 0-206.0288-84.992A290.7136 290.7136 0 0 0 512 734.4128z m0 77.4144A367.4112 367.4112 0 0 1 250.9824 184.32 368.64 368.64 0 1 1 512 811.8272z m0 0" p-id="18276"></path>
            </svg>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="padding10 border borderRadius10">
      <div class="borderBottom" style="padding-bottom: 5px; margin-bottom: 5px">
        <span class="fs20"> 门店智控</span>
      </div>
      <el-row class="padding10">
        <el-col :span="8">
          <el-button type="primary" size="mini" :loading="doorOpenLoading" style="width: 90px" @click="handleDoorOpen">门禁开</el-button>
        </el-col>
        <el-col :span="8">
          <el-button type="success" size="mini" style="width: 90px" :loading="lightOpenLoading" @click="handleLightOpen">灯光开</el-button>
        </el-col>
        <el-col :span="8">
          <el-button size="mini" style="width: 90px" :loading="lightCloseLoading" @click="handleLightClose">灯光关</el-button>
        </el-col><br><br>
        <el-col :span="8">
          <el-button type="primary" size="mini" style="width:90px;" :loading="arrvLoading" @click="activateInStore">到店模式</el-button>
        </el-col>
      </el-row>
      <a href="#" class="adding10" style="color: #b5b4bf">更多控制</a>
    </div>
    <el-dialog class="videoDialog" :close-on-click-modal="false" title="播放视频" :visible.sync="videoDialogVisible" width="670px" append-to-body>
      <video width="640" height="480" controls :src="videoUrl"></video>
    </el-dialog>
    <el-dialog v-dialogDrag v-if="videoDialogDragVisible" class="videoDialog" :close-on-click-modal="false" :modal="false" :modal-append-to-body="false" title="视频监控" :visible.sync="videoDialogDragVisible" width="620px" append-to-body>
      <videoDialog :device-id="videoData.code" :pwd="videoData.password" :store-name="videoData.storeName" :device-name="videoData.name" />
      <el-row type="flex" justify="end" style="margin-top: 10px">
        <el-button type="primary" plain @click="videoDialogDragVisible = false">关闭</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import clipboard from "@/utils/clipboard.min.js";
import videoDialog from "@/views/order/dialog/videoDialog.vue";
import store from "@/store";
export default {
  name: "OrderStore",
  props: {
    orderId: {
      type: String,
      default: "",
    },
  },
  components: {
    videoDialog,
  },
  data() {
    return {
      deviceRefreshLoading: false,
      videoDialogDragVisible: false,
      storeId: null,
      ccode: "",
      storeName: "",
      storeAddr: "",
      videoUrl: "",
      videoDialogVisible: false,
      btnLoading: false,
      deviceList: [{
        id: 1,
        pos: 1,
      },{
        id: 2,
        pos: 2,
      }],
      videoData: {},
      isDialog: true,
      doorOpenLoading: false,
      doorCloseLoading: false,
      lightOpenLoading: false,
      lightCloseLoading: false,
      arrvLoading: false,
      deviceInfo: {
        status: 1,
      },
      nickName: store.getters.nickName,
    };
  },
  mounted() {
    this.handleInit();
  },
  methods: {
    handleInit() {
      let url = `${this.baseUrls.third}/get/` + this.orderId;
      this.topsAjax.get(url).then((response) => {
        this.storeId = response.rstore;
        this.storeDevice();
      });
    },
    openVideo(item) {
      if (this.isDialog) {
        this.videoData = item;
        this.videoDialogDragVisible = true;
      } else {
        this.topsAjax.get(`${this.baseUrls.iot}/queryIMouDevice`, { storeId: this.storeId, pos: item.pos }).then((response) => {
          const url = `/components/videoWindows?deviceId=${response.deviceId}&channelId=0&pwd=&storeName=${this.storeName}&deviceName=${this.storeName}`;
          // 打开新标签页
          window.open(url, "_blank");
        });
      }
    },
    storeDevice() {
      if (this.storeId === null) {
        return;
      }
      this.topsAjax.get(`${this.baseUrls.orderStore}/selectById?sid=${this.storeId}`).then((response) => {
        this.ccode = response.store.ccode;
        this.storeName = response.store.cname;
        this.storeAddr = response.store.caddr;
      });
    },
    activateInStore() {
      this.arrvLoading = true;
      let url = `${this.baseUrls.iot}/activateInStore`;
      this.topsAjax.get(url, { storeId: this.storeId }).then(() => {
        this.arrvLoading = false;
        this.$message({
          message: "操作成功",
          type: "success",
        });
      });
    },
    handleDeviceRefresh() {
      this.deviceRefreshLoading = true;
      let url = `${this.baseUrls.iot}/uploadData`;
      this.topsAjax.get(url, { devUid: this.deviceInfo.code, type: this.deviceInfo.type }).then(() => {
        this.deviceRefreshLoading = false;
        this.$message({
          message: "操作成功",
          type: "success",
        });
        if (this.storeId) {
          this.topsAjax.get(`${this.baseUrls.iot}/queryDevice?storeId=${this.storeId}`).then((response) => {
            this.deviceInfo = response;
          });
        }
      });
    },
    handleDoorOpen() {
      this.doorOpenLoading = true;
      this.topsAjax.post(`${this.baseUrls.iot}/openOrClose`, { storeId: this.storeId, system: "tops-service", opera: this.nickName, type: "DOOR", openOrClose: 1 }).then(() => {
        this.doorOpenLoading = false;
        this.$message({
          message: "操作成功",
          type: "success",
        });
      }).catch(e => {
        this.doorOpenLoading = false
      });
    },
    handleLightOpen() {
      this.lightOpenLoading = true;
      this.topsAjax.post(`${this.baseUrls.iot}/openOrClose`, { storeId: this.storeId, system: "tops-service", opera: this.nickName, type: "LIGHT", openOrClose: 1 }).then(() => {
        this.lightOpenLoading = false;
        this.$message({
          message: "操作成功",
          type: "success",
        });
      });
    },
    handleLightClose() {
      this.lightCloseLoading = true;
      this.topsAjax.post(`${this.baseUrls.iot}/openOrClose`, { storeId: this.storeId, system: "tops-service", opera: this.nickName, type: "LIGHT", openOrClose: 0 }).then(() => {
        this.lightCloseLoading = false;
        this.$message({
          message: "操作成功",
          type: "success",
        });
      });
    },
    handleStoreImgUrlHref() {
      this.topsAjax.get(`${this.baseUrls.file}/list/${this.storeId}`).then((res) => {
        for (let i = 0; i < res.length; i++) {
          if (res[i].cformat === "jpg") {
            window.location.href = res[i].curl;
            return;
          }
        }
        this.$message({
          type: "error",
          message: "该门店未上传图片文件",
        });
      });
    },
    handleStoreVideoUrlCopy() {
      this.topsAjax.get(`${this.baseUrls.file}/list/${this.storeId}`).then((res) => {
        for (let i = 0; i < res.length; i++) {
          if (res[i].cformat === "mp4") {
            clipboard.copy(res[i].curl);
            this.$message({
              type: "success",
              message: "复制成功",
            });
            return;
          }
        }
        this.$message({
          type: "error",
          message: "该门店未上传视频文件",
        });
      });
    },
    handleStoreVideoShow() {
      this.topsAjax.get(`${this.baseUrls.file}/list/${this.storeId}`).then((res) => {
        for (let i = 0; i < res.length; i++) {
          if (res[i].cformat === "mp4") {
            this.videoUrl = res[i].curl;
            this.videoDialogVisible = true;
            return;
          }
        }
        this.$message({
          type: "error",
          message: "该门店未上传视频文件",
        });
      });
    },
    handleStoreImgUrlCopy() {
      this.topsAjax.get(`${this.baseUrls.file}/list/${this.storeId}`).then((res) => {
        for (let i = 0; i < res.length; i++) {
          if (res[i].cformat === "jpg") {
            clipboard.copy(res[i].curl);
            this.$message({
              type: "success",
              message: "复制成功",
            });
            return;
          }
        }
        this.$message({
          type: "error",
          message: "该门店未上传视频文件",
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
